import React from 'react'
import { AuthzAccessDeniedReason } from '../../containers/WorkspaceAccessDeniedApp'

export interface Workspace {
  id: string
  slug: string
  name: string
  isCurrentUserOwner: boolean
  isCurrentUserMember: boolean
  billing: {
    email: string
    planId: string
    planName: string
    inTrial: boolean
    isFreeAccount: boolean
    isOnBusinessTier: boolean
    isOnInvoicedPlan: boolean
    isOnSelfServicePlan: boolean
    usingTieredBilling: boolean
  }
  entitlements: Entitlements
}

interface EntitlementConnections {
  sources: number | null
}

interface EntitlementLimits {
  connections: EntitlementConnections
}

interface Entitlements {
  quotas: EntitlementLimits
  features: EntitlementFeatures
}

interface EntitlementFeatures {
  warehouseSelectiveSyncs: boolean
}

export interface ContextProps {
  accessDeniedReason: AuthzAccessDeniedReason
  error: Error | null
  isLoading: boolean
  isNotFound: boolean
  refreshWorkspace: () => any
  workspace: null | Workspace
  workspaceId: string | null
  workspaceSlug: string | null
}

const defaultState: ContextProps = {
  accessDeniedReason: undefined,
  error: null,
  isLoading: false,
  isNotFound: false,
  refreshWorkspace: () => {},
  workspace: null,
  workspaceId: null,
  workspaceSlug: null
}

export default React.createContext<ContextProps>(defaultState)
